import styles from './NewFeatures.module.css'

const NewFeatures = () => {
  return (
    <section className={styles.newFeatures}>
      <div className={styles.container}>
        <div className={styles.titleSection}>
          <h2 className={styles.title}>
            <span className={styles.highlight}>N</span>ew-Age.{' '}
            <span className={styles.highlight}>E</span>xperienced.{' '}
            <span className={styles.highlight}>W</span>orry-Free.
          </h2>
        </div>
        <div className={styles.descriptionSection}>
          <p className={styles.description}>
            Embrace the future of HVAC solutions with our cutting-edge technology and years of expertise. We provide seamless, worry-free service, ensuring optimal comfort and efficiency for every space.
          </p>
        </div>
      </div>
    </section>
  )
}

export default NewFeatures
